import { deleteTypes } from "../api/deleteTypes";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useDeleteTypes = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids: number[]) => deleteTypes(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetTypes"]);
      toast.fire("Success", "Types were deactivated successfully", "success");
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Types failed",
        "Server Error: Cannot deactivate Types",
        "error"
      );
    },
  });

  return mutate;
};

export default useDeleteTypes;
